import styles from "./index.module.scss"

const RewardRequestDisabled: React.FC = () => {
  return (
    <div className={styles.requestDisabled}>
      <h2 className={styles.requestDisabled_title}>
        クリエイターの都合によりギフトを贈ることができません。
      </h2>
      <p className={styles.requestDisabled_text}>
        現在クリエイターはギフトを贈れない状態となっています。
        <br />
        そのため、依頼についても行うことができません。 <br />
        クリエイターへギフトを贈れるようになるまでお待ちください。
      </p>
    </div>
  )
}

export default RewardRequestDisabled
